<!--文化纪首页 大课间展演 20211123-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box">
 

        <div style="position:relative;">
          <div style="padding: 10px;"><img style="width: 100%; " src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230425/user-0/20230425/a1bd4950e71614d8d809ed975938d3a0.jpeg?x-oss-process=style/tb-750"/></div>
          <div class="savebtn" style="text-align: center ;     position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;"> 
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianCertSearch',query:{}}">下载证书
            </van-button>
            <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApply',query:{}}">我要报名
            </van-button> -->
             <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApplyList',query:{}}">申报列表
            </van-button> -->

            <van-button
                style="width: 3rem ; margin: 0 auto"
                size="normal" round @click="go()">活动专题
            </van-button>

          </div>
        </div>

    </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
  margin: 0.2rem auto;
}

.news-title {
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
}

.news-read-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.2rem;
}

.news-content {
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 20px;
  color: rgba(34, 34, 34, 1);
  line-height: 28px;
}

.news-content >>> img {
  max-width: 100% !important;
}

.news-content >>> iframe {
  width: 100% !important;
}

.row1 {
  /*padding: 10px;*/
  margin: 0 10px;
}

.row4 {
  display: flex;
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  height: 65px;
  /*flex-wrap: wrap;*/
}

.row4 img {
  /*width: calc(25% - 10px);*/
  flex: 1;
  width: 25%;
  /*margin: 0 10px 10px 0;*/
}

.row4 img + img {

  margin-left: 10px;

}

</style>

<script>
import Vue from "vue";
import {Tab, Tabs, List, PullRefresh, Toast} from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(Toast);

export default {
  name: "Wenhuaji",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    LoginDialog
  },

  data: function () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [],
      catelist: [],
      list: [],
      row: {},
      params: {
        cate_id: 64,
        pageNo: 1,
        pageSize: 10
      },
      dakejian: {
        dabiao_url:''
      }
    };
  },
  filters: {},
  mounted() {
    document.title = "大课间";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    let that = this;
 

    this.fetch();
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/cms/cmslist', {
        cate_id: 65
      }, (res) => {
        that.list = res.data.list;
        that.list = that.list.filter(item =>{
          return item.cate_ids.indexOf('65')!=-1
        })
      }, (res) => {
        // Toast.fail(res.msg);
      })

      that.$api.post('/api/dakejian/detail', {}, (res) => {
        that.dakejian = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    toast(msg){
      Toast(msg);
    },

    go(type) {
      // rbLink({name:'H5',query:{ url : this.dakejian.jump_url } });
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: that.dakejian.jump_url,
        }
      });
    },

    gowenjuan() {
      // rbLink({name:'H5',query:{ url : this.dakejian.jump_url } });
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: 'https://qywx.wjx.cn/vm/QMVGNRB.aspx',
        }
      });
    },
    go2(type) {
      rbLink({name: 'Page331', query: {}});
    },

    go3(type) {
      rbLink({name: 'CRuralList', query: {}});
    },
    goDabiao(){
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: that.dakejian.dabiao_url,
        }
      });
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// Dakejian.vue?dbc2cc36